/* eslint-disable */
import { AUTH_LOGOUT, AUTH_LOGOUT_COMPLETE, AUTH_LOGOUT_ERROR, AUTH_LOGOUT_SUCCESS } from '../Auth.types';

/**
 * Logout an user and fire the appropriate actions
 * @returns {ActionCreator<FromPromise<null, Error, {}, AUTH_LOGOUT, AUTH_LOGOUT_COMPLETE, AUTH_LOGOUT_ERROR, AUTH_LOGOUT_SUCCESS>>} The created `Action`
 */
const authLogout = () => ({ authService, fromPromise }) => {
  const promise = authService.logout();
  return fromPromise(promise, {}, [AUTH_LOGOUT, AUTH_LOGOUT_COMPLETE, AUTH_LOGOUT_ERROR, AUTH_LOGOUT_SUCCESS]);
};

export default authLogout;
